import request from "@/utils/request";
// 获取接收人列表
export function ClickWjdc(params) {
  return request({
    url: "/h5/member/clickWjdc",
    method: "post",
    params,
  });
}
// 确定接收人
export function GetWjdcStatus(params) {
  return request({
    url: "/h5/member/getWjdcStatus",
    method: "post",
    params,
  });
}